import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useMatch, useNavigate } from 'react-router-dom'

import RouteConstants from '../routes';
import CartContents from './CartContents';
import Waiting from './Waiting';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

import { isTrue, includesSubscription } from '../utils';

import { resetErrorMessage, fetchCart, deleteFromCart, checkout } from '../actions';
	
const CartButtonDialog = () => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const dispatch = useDispatch();
	const user = useSelector(state => state.user);
	const cart = useSelector(state => state.cart.data);
	const permissions = useSelector(state => state.permissions);
	const memberSettings = useSelector(state => state.settings.members.data);
	const message = useSelector(state => state.cart.message);
	const submitting = useSelector(state => state.cart.submitting);
	const navigate = useNavigate();
	const isCartPage = useMatch('/cart/');
	
	const [submitted, setSubmitted] = useState(false);
	const [cartError, setCartError] = useState(false);
	const [termsRequired, setTermsRequired] = useState(true);

	useEffect(() => {
		if(user.member_no > 0){
			dispatch(fetchCart())
		}
	}, [dispatch, user])

	useEffect(() => {
		setSubmitted(false)
		setCartError(false);
	}, [cart])
	
	// submitted is not in the dependency array b/c we only want to run this when message changes
	useEffect(() => {
		if(submitted && message !== ''){
			setCartError(true);
		} // eslint-disable-next-line
	}, [message])
	
	useEffect(() => {
		if(isTrue(memberSettings.show_terms_and_conditions) && includesSubscription(cart)){
			setTermsRequired(true);
		} else {
			setTermsRequired(false);
		}
	},[memberSettings, cart])
	
	const [cartOpen, setCartOpen] = useState(false);
	
	if(!permissions.cart_available || cart.length === 0){
		return null;
	}
	
	const dispatchDelete = (course_code) => {
		dispatch(resetErrorMessage());
		setCartError(false);
		setSubmitted(true);
		dispatch(deleteFromCart(course_code));
	}
	
	const dismissError = () => {
		setSubmitted(false);
		setCartError(false);
		dispatch(fetchCart(true));
		dispatch(resetErrorMessage());
	}
	
	const closeDialog = () => {
		setCartOpen(false);
		dismissError();
	}
	
	const checkoutRequest = () => {
		if(!termsRequired){
			dispatch(checkout());
		}
		navigate('/checkout');
		setCartOpen(false);
	}
	
	const SubmitResult = () => {
		if(cartError){
			return <>
			<DialogContent dividers>
			<Typography variant='h6' component='h3' gutterBottom>Error</Typography>
			<Typography paragraph>Request failed.</Typography>
			<Typography paragraph>{message}</Typography>
			</DialogContent>
			<DialogActions>
			<Button onClick={() => closeDialog()} color="primary">
			Close
			</Button>
			<Button color="primary" onClick={() => dismissError()} >
			Back to cart
			</Button>
			</DialogActions>
			</>
		} else {
			return <DialogContent dividers>
			<Waiting message='Submitting request. Please wait...' />
			</DialogContent>
		}
	}
	
	return (
	<>
	<Button color="inherit" 
		size='small'
		variant='outlined'
		startIcon={RouteConstants.cart.icon}
		onClick={() => { isCartPage ? navigate('/cart') : setCartOpen(true)}}
		>
		{cart.length} in cart
	</Button>
	<Dialog
		open={cartOpen}
		onClose={() => closeDialog()}
		fullScreen={!isSm}
		aria-labelledby="cart-dialog-title"
		className={classes.settingsDialog}
		>
		<DialogTitle id="cart-dialog-title">Cart</DialogTitle>
		{submitted ? <SubmitResult/> :
		<>
		<DialogContent dividers>
			<CartContents 
				flexLayout={!isSm} 
				handleRemoveItem={dispatchDelete}
			/>
		</DialogContent>
		<DialogActions>
			<Button onClick={() => closeDialog()} color="primary">
			Close
			</Button>
			<Button color="primary" disabled={submitting} onClick={() => dispatchDelete(false)} >
			Clear cart
			</Button>
			<Button color="primary" variant="contained" onClick={() => checkoutRequest()}>Checkout</Button>
        </DialogActions>
		</> }
	</Dialog>
	</>
)};

export default CartButtonDialog